/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/exports-last */
import PartType from '../../constants/PartType'
import { isPartAllowedForDifm3 } from '../../utility/allowedPartsForDifm3'

export interface IAllowedPartKeyValue {
  [partName: string]: PartType[]
}

/* This filter will refine the allowed parts for DIFM3 globally regardless of the feature flag implementation.
* For the RepairPal Pricing Integration V2, the allowed parts will be shown on the Install At Shop component only
* if there's a 'rpp_<partname>' rule in Optimizely and if it's defined in the enum 'InstallationPartsAllowed',
* otherwise the RepairPal integration V1 will take place.
* For the legacy DIFM integration (Pricing V1), the allowed parts will be shown on the Install At Shop component only if
* there's NO MATCH for the rpp_<partname> rule in Optimizely and if it's defined in the enum 'InstallationPartsAllowed',
* otherwise the DIFM2 component should be displayed if the cookie difm=1 is found.
*/
const allowedPartsForDifmMasterFilter: IAllowedPartKeyValue | undefined = {
  mirror: [PartType.Component, PartType.Set],
  headlight: [PartType.Component, PartType.Set],
  'tail-light': [PartType.Component, PartType.Set],
}

const useAllowedPartsFlag = () => {
  const isPartAllowedForDifm3FromFlag =
   (part: string, isKit: boolean, kitType?: string): boolean => isPartAllowedForDifm3(part, isKit, kitType, allowedPartsForDifmMasterFilter)

  return { isPartAllowedForDifm3: isPartAllowedForDifm3FromFlag, allowedPartsForDifmMasterFilter }
}

export default useAllowedPartsFlag
